import GlobalStyleComponent from "/home/semaphore/rbma-academy-archive/src/utils/GlobalStyleComponent";
export default GlobalStyleComponent;
